import Accordion from 'accordion-js';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const currentAccordionID = window.location.hash;
  const containers = document.querySelectorAll('.accordion-container');

  if (0 < containers.length) {
    containers.forEach((container) => {
      const openedAccordions = [];
      let currentAccordion = null;

      // Check for hash-based accordion first
      if (currentAccordionID) {
        currentAccordion = container.querySelector('.ac' + currentAccordionID);
      }

      // If hash-based accordion found, use it
      if (currentAccordion) {
        const currentGroup = currentAccordion.parentNode;
        const currentIndex = Array.prototype.indexOf.call(
          currentGroup.children,
          currentAccordion
        );
        openedAccordions.push(currentIndex);
      } else {
        // Otherwise, find accordions marked as open by default
        const allAccordions = container.querySelectorAll('.ac');

        allAccordions.forEach((accordion, index) => {
          const openByDefault = accordion.getAttribute('data-open-by-default');
          if (openByDefault === 'true') {
            openedAccordions.push(index);
          }
        });
      }

      new Accordion(container, {
        duration: 400,
        showMultiple: true,
        openOnInit: openedAccordions,
      });
    });
  }
});
